import { Component, Input } from "@angular/core";
@Component({
  selector: "bfx-checkbox-icon-small",
  template: `<p-checkbox
    label="{{ label }}"
    [disabled]="disabled"
    [(ngModel)]="checked"
    binary="true"
  ></p-checkbox>`,
  standalone: false,
})
export class BfxCheckboxIconSmallComponent {
  @Input() label: string;
  @Input() checked: boolean;
  @Input() disabled: boolean;
}
